import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { caminoService } from '@/services/camino.service';
import { isCaminoMemberImportInProgress } from '@/types';

const CAMINO_MEMBER_IMPORTS_POLL_INTERVAL_MS = 10000;

export const useCaminoMemberImports = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CAMINO_MEMBER_IMPORTS, churchId],
    queryFn: () => caminoService.getCaminoMemberImports(churchId ?? ''),
    enabled: !!churchId,
    refetchInterval: (query) => {
      const imports = query.state.data;
      if (!imports?.some((importRun) => isCaminoMemberImportInProgress(importRun.status))) {
        return false;
      }
      return CAMINO_MEMBER_IMPORTS_POLL_INTERVAL_MS;
    },
  });
};
